.module-steps-container {
    width: 67%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.module-learn-more-container {
    width: 33%;
}

.progress-bar-container {
    width: 100px;
}

.illustration {
    min-width: 120px;
    align-self: stretch;
    display: flex;
}

.connect-meeting-modal-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--blue-xlt);
}

.module-header-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;
}

.module-header-container.is-expanded {
    border-bottom: 1px solid var(--off-white-dk);
}

.module-header-container:hover {
    background-color: var(--off-white);
}
